var map = {
	"./back.png": 717,
	"./effect-02.png": 718,
	"./effect-03.png": 719,
	"./planet-background.jpg": 720,
	"./planet-background_o.jpg": 721,
	"./planet-key.png": 722,
	"./planet-level11.png": 723,
	"./planet-level12.png": 724,
	"./planet-level13.png": 725,
	"./planet-level14.png": 726,
	"./planet-level15.png": 727
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 716;